import {
	type OdometerHistoryOrigin,
	VEHICLE_ODOMETER_SOURCE,
	type VehicleOdometerSourceApi,
} from "../types/odometer-ui.types";

export function mapOdometerApiSourceToHistoryOrigin(
	source: VehicleOdometerSourceApi
): OdometerHistoryOrigin {
	if (source === VEHICLE_ODOMETER_SOURCE.TELEMETRY) {
		return "TELEMETRIA";
	}
	if (source === VEHICLE_ODOMETER_SOURCE.CHECKLIST) {
		return "CHECKLIST";
	}
	return "MANUAL";
}
